import React from 'react';
import { motion } from 'framer-motion';
import './RACPhilosophy.css';

const RACPhilosophy = () => {
  console.log('[RACPhilosophy] Component rendered');
  
  return (
    <section className="rac-philosophy">
      <div className="rac-philosophy-container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="rac-philosophy-content"
        >
          <h2 className="rac-section-title">A Different Way to Think About Wealth</h2>
          <div className="rac-gold-line"></div>
          <div className="rac-philosophy-text">
            <p>
              For generations, Indian families built wealth through land, livestock, and food production—assets that worked quietly, served society, and endured.
            </p>
            <p>
              The Rent-A-Cow (RAC) Program is a modern continuation of that wisdom. It is built on ownership, responsibility, and clarity—not speculation.
            </p>
            <p>
              You are not chasing trends. You are choosing stability, dignity, and long-term thinking.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default RACPhilosophy;


